import { css } from 'styled-components';
export const SitePaddingMin = 18;
export const SitePaddingMax = 64;
export const SiteWidth = 1760;
export const SiteWidthBreakpoint = SiteWidth + SitePaddingMax * 2;
export const SiteWidthNarrow = 940;
export const siteWide = css `
  margin: 0 auto;
  max-width: var(--siteWidth);
  padding: 0 var(--sitePadding);
  width: 100%;
`;
export const baseGrid = css `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(24, 1fr);
`;
